import {
  ISettingKey,
  IPersonalInformationShortType,
  IThirdPartyTermsType,
} from './type';
import ICON_UNCHECK_LIGHT from '../../public/static/icon-radio-off-light.svg';
import ICON_UNCHECK from '../../public/static/icon-radio-off.svg';
import ICON_CHECK_LIGHT from '../../public/static/icon-radio-on-light.svg';
import ICON_CHECK from '../../public/static/icon-radio-on.svg';
import {ITheme} from '../common/type';
import {sendEvent} from '../common/util/tracking';

export function getChildrenThirdPartyTermsTitle(type: IThirdPartyTermsType) {
  return `${
    type === 'service' ? '(필수)' : '(선택)'
  } 아동의 개인정보 제3자 제공 동의`;
}

export function getPersonalInformationShortTitle(
  type: IPersonalInformationShortType
) {
  return `${
    type === 'auth' ? '(필수)' : '카카오웹툰'
  } 개인정보 수집 및 이용 동의`;
}

export function sendMoreEvent({
  actionName,
  customProps,
  page = 'sidemenu',
  section = 'sidemenu',
}: {
  actionName: string;
  section?: string;
  customProps?: {[key: string]: any};
  page?: string;
}) {
  sendEvent({
    section,
    page,
    actionName,
    action: 'click',
    customProps,
  });
}

export function sendSettingEvent({
  actionName,
  customProps,
  page = 'setting_account',
  section = 'setting',
}: {
  actionName: string;
  section?: string;
  customProps?: {[key: string]: string};
  page?: string;
}) {
  sendEvent({section, page, actionName, action: 'click', customProps});
}

export const SETTING_LOG_ACTION_NAME: {
  [key in ISettingKey]: string;
} = {
  'episode-sort': 'ep_sort',
  theme: 'display_theme',
  'third-party': 'privacy_provide_setting',
};

type IInquiryRadioThemeKey = 'checkOnIcon' | 'checkOffIcon';

export const RADIO_THEME_ICON_MAP: {
  [key in ITheme]: {
    [key in IInquiryRadioThemeKey]: string;
  };
} = {
  light: {
    checkOnIcon: ICON_CHECK_LIGHT,
    checkOffIcon: ICON_UNCHECK_LIGHT,
  },
  dark: {
    checkOnIcon: ICON_CHECK,
    checkOffIcon: ICON_UNCHECK,
  },
};

export const circledNumber = (num: number) => {
  return String.fromCharCode(9311 + num);
};

export const HISTORY_ITEM_CN =
  'border-b border-solid border-grey-03 py-16 last:border-none';
